import { HUB_CONNECTION } from "./hubActionTypes";
import { Common } from "../../utils";
import { isUndefined } from 'lodash';
import { handleRealtimeNotification, incrementUnreadCount } from "../domain/notifications/notificationActions";

// eslint-disable-next-line import/no-anonymous-default-export
export default store => {
  return next => action => {
    // Check if this is a real-time action
    if (!isUndefined(action) && !isUndefined(action.realTime) && action.realTime === true) {
      const { accountReducer } = store.getState();
      const { name, message, history } = action.payload || {};

      // Show notification message if available
      if (message) {
        Common.showSuccessMessage(message);
      }

      // Handle different real-time action types
      switch (action.type) {
        case HUB_CONNECTION.METHODS.USER_LOGIN:
          console.log('User login notification received:', action.payload);
          // Handle user login notifications
          break;

        case HUB_CONNECTION.METHODS.LEAVE_REQUEST:
          console.log('Notification update received:', action.payload);
          // Handle notification updates - strip non-serializable history before storing in Redux
          if (action.payload) {
            const { history: _history, ...notificationPayload } = action.payload;
            store.dispatch(handleRealtimeNotification(notificationPayload));
            // Increment unread count for the notification badge
            store.dispatch(incrementUnreadCount());
          }
          break;

        case HUB_CONNECTION.METHODS.NOTIFICATION_UPDATE:
          console.log('General notification received:', action.payload);
          // Handle general notifications - strip non-serializable history before storing in Redux
          if (action.payload && action.payload.notification) {
            const { history: _history, ...rest } = action.payload.notification;
            store.dispatch(handleRealtimeNotification(rest));
            // Increment unread count for the notification badge
            store.dispatch(incrementUnreadCount());
          }
          break;

        default:
          console.log('Unknown real-time action:', action.type, action.payload);
          break;
      }
    }

    return next(action);
  };
};
